import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";

export default function AllPublisher() {
  return (
    <>
      <Sidebar activeItem="all-publisher" />

      <div className="content-wrapper">
        <TitleBar title="جایگاه های تبلیغاتی شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      جایگاه های تبلیغاتی شما به دو دسته وابسته به صفحه و مستقل
                      از صفحه تقسیم می شود.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      برای مدیریت جایگاه های تبلیغاتی وابسته ابتدا باید صفحه
                      بسازید.{" "}
                    </p>
                  </li>
                </ul>
              </div>
              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>آدرس</td>
                      <td>دسته بندی موضوع</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>۱</td>
                      <td className="text-left">
                        <a target="_blank" href="https://batmatic-test.ir">
                          batmatic-test.ir
                        </a>
                      </td>
                      <td>یراق آلات چوپ و دکراسیون</td>
                      <td>
                        <span className="pl-2">
                          <Link
                            to="/page/all/publisher/1"
                            className="btn btn-primary"
                          >
                            نمایش صفحات جایگاه های تبلیغاتی
                          </Link>
                        </span>
                        <span>
                          <Link
                            to="/positions/independent/all/web-site-publisher/1"
                            className="btn btn-info"
                          >
                            نمایش جایگاه های مستقل تبلیغاتی
                          </Link>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="pt-2">
                <Link className="btn btn-primary" to="/positions/list">
                  لیست جایگاه های تبلیغاتی شما{" "}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
